import { Button, Icon, MenuItem, Popover, Typography } from '@material-ui/core'
import classNames from 'classnames'
import * as React from 'react'
import Bible from 'src/bible/Bible'
import BibleVerse from 'src/bible/BibleVerse'
import './Transport.css'

interface Props {
    focusedVerse: BibleVerse;
    bible: Bible;
    showVerse: boolean;
    onBookChange: (bookIndex: number) => void;
    onChapterChange: (chapterIndex: number) => void;
    onVerseChange: (verseIndex: number) => void;
}

interface State {
    bookMenuAnchor: HTMLElement | null;
    chapterMenuAnchor: HTMLElement | null;
    verseMenuAnchor: HTMLElement | null;
}

export class Transport extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            bookMenuAnchor: null,
            chapterMenuAnchor: null,
            verseMenuAnchor: null
        };
        this.previousBook = this.previousBook.bind(this);
        this.nextBook = this.nextBook.bind(this);
        this.previousChapter = this.previousChapter.bind(this);
        this.nextChapter = this.nextChapter.bind(this);
        this.previousVerse = this.previousVerse.bind(this);
        this.nextVerse = this.nextVerse.bind(this);
        this.openBookMenu = this.openBookMenu.bind(this);
        this.closeBookMenu = this.closeBookMenu.bind(this);
        this.onBookClick = this.onBookClick.bind(this);
        this.openChapterMenu = this.openChapterMenu.bind(this);
        this.closeChapterMenu = this.closeChapterMenu.bind(this);
        this.onChapterClick = this.onChapterClick.bind(this);
        this.openVerseMenu = this.openVerseMenu.bind(this);
        this.closeVerseMenu = this.closeVerseMenu.bind(this);
        this.onVerseClick = this.onVerseClick.bind(this);
    }

    // tslint:disable:jsx-no-lambda
    public render(): React.ReactNode {
        const disabledButtons = {
            previousBook: !this.props.bible.isBookIndex(this.props.focusedVerse.getBook().getIndex() - 1),
            nextBook: !this.props.bible.isBookIndex(this.props.focusedVerse.getBook().getIndex() + 1),
            previousChapter: !this.props.bible.isChapterIndex(this.props.focusedVerse.getChapter().getIndex() - 1),
            nextChapter: !this.props.bible.isChapterIndex(this.props.focusedVerse.getChapter().getIndex() + 1),
            previousVerse: !this.props.bible.isVerseIndex(this.props.focusedVerse.getIndex() - 1),
            nextVerse: !this.props.bible.isVerseIndex(this.props.focusedVerse.getIndex() + 1)
        };

        return (
            <nav className="Transport">
                <div className="Transport_Group Transport_BookGroup">
                    <Button
                        className="Transport_Button"
                        disabled={disabledButtons.previousBook}
                        onClick={this.previousBook}>
                        <Icon color={disabledButtons.previousBook ? 'disabled': undefined}>chevron_left</Icon>
                    </Button>
                    <Button className="Transport_TextButton" onClick={this.openBookMenu}>
                        <Typography className="Transport_Text" variant="h6">{this.props.focusedVerse.getBook().getName()}</Typography>
                    </Button>
                    <Button
                        className="Transport_Button"
                        disabled={disabledButtons.nextBook}
                        onClick={this.nextBook}>
                        <Icon color={disabledButtons.nextBook ? 'disabled': undefined}>chevron_right</Icon>
                    </Button>
                </div>
                <div className="Transport_Group Transport_ChapterGroup">
                    <Button
                        className="Transport_Button"
                        disabled={disabledButtons.previousChapter}
                        onClick={this.previousChapter}>
                        <Icon color={disabledButtons.previousChapter ? 'disabled': undefined}>chevron_left</Icon>
                    </Button>
                    <Button className="Transport_TextButton" onClick={this.openChapterMenu}>
                        <Typography className="Transport_Text" variant="h6">
                            <span className="Transport_Label">Chapter</span> {this.props.focusedVerse.getChapter().getNumber()} <span
                                className="Transport_SubText">of {this.props.focusedVerse.getBook().getChapterCount()}</span>
                        </Typography>
                    </Button>
                    <Button
                        className="Transport_Button"
                        disabled={disabledButtons.nextChapter}
                        onClick={this.nextChapter}>
                        <Icon color={disabledButtons.nextChapter ? 'disabled': undefined}>chevron_right</Icon>
                    </Button>
                </div>
                {this.props.showVerse && <div className="Transport_Group Transport_VerseGroup">
                    <Button
                        className="Transport_Button"
                        disabled={disabledButtons.previousVerse}
                        onClick={this.previousVerse}>
                        <Icon color={disabledButtons.previousVerse ? 'disabled': undefined}>chevron_left</Icon>
                    </Button>
                    <Button className="Transport_TextButton" onClick={this.openVerseMenu}>
                        <Typography className="Transport_Text" variant="h6">
                            <span className="Transport_Label">Verse</span> {this.props.focusedVerse.getNumber()} <span
                                className="Transport_SubText">of {this.props.focusedVerse.getChapter().getVerseCount()}</span>
                        </Typography>
                    </Button>
                    <Button
                        className="Transport_Button"
                        disabled={disabledButtons.nextVerse}
                        onClick={this.nextVerse}>
                        <Icon color={disabledButtons.nextVerse ? 'disabled': undefined}>chevron_right</Icon>
                    </Button>
                </div>}

                {this.renderBookMenu()}
                {this.renderChapterMenu()}
                {this.props.showVerse && this.renderVerseMenu()}
            </nav>
        );
    }

    private renderBookMenu(): React.ReactNode {
        const focusedBookIndex = this.props.focusedVerse.getBook().getIndex();
        // tslint:disable:jsx-no-lambda
        return (
            <Popover
                PaperProps={{ className: 'Transport_Menu' }}
                anchorEl={this.state.bookMenuAnchor}
                open={this.state.bookMenuAnchor !== null}
                onClose={this.closeBookMenu}>
            {/*<Menu anchorEl={this.state.bookMenuAnchor} open={this.state.bookMenuAnchor !== null} onClose={this.closeBookMenu}>*/}
                {this.props.bible.getBooks().map((book) =>
                    <MenuItem
                        key={book.getIndex()}
                        component="div"
                        className={classNames('Transport_MenuItem', { 'Transport_MenuItemMarker': ['Genesis', 'Matthew'].includes(book.getName()) })}
                        selected={book.getIndex() === focusedBookIndex}
                        onClick={() => this.onBookClick(book.getIndex())}>
                        {book.getName()}
                    </MenuItem>
                )}
            {/*</Menu>*/}
            </Popover>
        );
        // tslint:enable:jsx-no-lambda
    }

    private renderChapterMenu(): React.ReactNode {
        const focusedChapterIndex = this.props.focusedVerse.getChapter().getIndex();
        // tslint:disable:jsx-no-lambda
        return (
            <Popover
                PaperProps={{ className: 'Transport_Menu' }}
                anchorEl={this.state.chapterMenuAnchor}
                open={this.state.chapterMenuAnchor !== null}
                onClose={this.closeChapterMenu}>
            {/*<Menu anchorEl={this.state.chapterMenuAnchor} open={this.state.chapterMenuAnchor !== null} onClose={this.closeChapterMenu}>*/}
                {this.props.focusedVerse.getBook().getChapters().map((chapter) =>
                    <MenuItem
                        key={chapter.getIndex()}
                        component="div"
                        className="Transport_MenuItem"
                        selected={chapter.getIndex() === focusedChapterIndex}
                        onClick={() => this.onChapterClick(chapter.getIndex())}>
                        {chapter.getName()}
                    </MenuItem>
                )}
            {/*</Menu>*/}
            </Popover>
        );
        // tslint:enable:jsx-no-lambda
    }

    private renderVerseMenu(): React.ReactNode {
        const focusedVerseIndex = this.props.focusedVerse.getIndex();
        // tslint:disable:jsx-no-lambda
        return (
            <Popover
                PaperProps={{ className: 'Transport_Menu' }}
                anchorEl={this.state.verseMenuAnchor}
                open={this.state.verseMenuAnchor !== null}
                onClose={this.closeVerseMenu}>
            {/*<Menu anchorEl={this.state.verseMenuAnchor} open={this.state.verseMenuAnchor !== null} onClose={this.closeVerseMenu}>*/}
                {this.props.focusedVerse.getChapter().getVerses().map((verse) =>
                    <MenuItem
                        key={verse.getIndex()}
                        component="div"
                        className="Transport_MenuItem"
                        selected={verse.getIndex() === focusedVerseIndex}
                        onClick={() => this.onVerseClick(verse.getIndex())}>
                        {verse.getName()}
                    </MenuItem>
                )}
            {/*</Menu>*/}
            </Popover>
        );
        // tslint:enable:jsx-no-lambda
    }

    private previousBook(): void {
        const index = this.props.focusedVerse.getBook().getIndex() - 1;
        if (this.props.bible.isBookIndex(index)) {
            this.props.onBookChange(index);
        }
    }

    private nextBook(): void {
        const index = this.props.focusedVerse.getBook().getIndex() + 1;
        if (this.props.bible.isBookIndex(index)) {
            this.props.onBookChange(index);
        }
    }

    private previousChapter(): void {
        const index = this.props.focusedVerse.getChapter().getIndex() - 1;
        if (this.props.bible.isChapterIndex(index)) {
            this.props.onChapterChange(index);
        }
    }

    private nextChapter(): void {
        const index = this.props.focusedVerse.getChapter().getIndex() + 1;
        if (this.props.bible.isChapterIndex(index)) {
            this.props.onChapterChange(index);
        }
    }

    private previousVerse(): void {
        const index = this.props.focusedVerse.getIndex() - 1;
        if (this.props.bible.isVerseIndex(index)) {
            this.props.onVerseChange(index);
        }
    }

    private nextVerse(): void {
        const index = this.props.focusedVerse.getIndex() + 1;
        if (this.props.bible.isVerseIndex(index)) {
            this.props.onVerseChange(index);
        }
    }

    private openBookMenu(event: React.MouseEvent<HTMLElement>): void {
        this.setState({ bookMenuAnchor: event.currentTarget });
    }

    private closeBookMenu(): void {
        this.setState({ bookMenuAnchor: null });
    }

    private onBookClick(bookIndex: number): void {
        this.props.onBookChange(bookIndex);
        this.closeBookMenu();
    }

    private openChapterMenu(event: React.MouseEvent<HTMLElement>): void {
        this.setState({ chapterMenuAnchor: event.currentTarget });
    }

    private closeChapterMenu(): void {
        this.setState({ chapterMenuAnchor: null });
    }

    private onChapterClick(chapterIndex: number): void {
        this.props.onChapterChange(chapterIndex);
        this.closeChapterMenu();
    }

    private openVerseMenu(event: React.MouseEvent<HTMLElement>): void {
        this.setState({ verseMenuAnchor: event.currentTarget });
    }

    private closeVerseMenu(): void {
        this.setState({ verseMenuAnchor: null });
    }

    private onVerseClick(verseIndex: number): void {
        this.props.onVerseChange(verseIndex);
        this.closeVerseMenu();
    }
}
